<ng-container *ngTemplateOutlet="language === 'en' ? en : fr " />

<!--TEMPLATES ENGLISH-->
<ng-template #en>
  <div class="td-wb-preferences__agreement-form">
    <h1 class="td-wb-preferences__agreement-form__header">AMEX Subscriber Agreement - Non-Professional</h1>
    @if (disabled()) {
      <td-wb-notification class="td-wb-preferences-agreements__completed"
                          notificationType="success">
        Copy for "Viewing Purposes only" :
        No action required, this agreement has been accepted. Thank You.
      </td-wb-notification>
    }
    <p class="td-wb-preferences__agreement-form--title">AMEX Agreement for Market Data Display Services<br>(Usage-Based
    Services/Nonprofessional Subscriber Status)</p>
    <p class="td-wb-preferences__agreement-form--copy">TD Waterhouse Canada Inc. ("Vendor") agrees to make "Market Data" available to you pursuant
      to the terms and conditions set forth in this agreement. By manifesting your assent in the space indicated
      below, you ("Subscriber") agree to comply with those terms and conditions. Section 1 sets forth terms
      and conditions of general applicability. Section 2 applies insofar as Subscriber receives and uses Market Data
    made available pursuant to this Agreement as a Nonprofessional Subscriber.</p>

    <ol class="td-wb-preferences__agreement-form--primary td-wb-preferences__agreement-form--copy">
      <p class="td-wb-preferences__agreement-form--title td-wb-preferences__agreement-form--inline-title">SECTION 1: TERMS AND CONDITIONS OF GENERAL APPLICABILITY</p>
      <li class="td-wb-preferences__agreement-form--primary-item"><span class="td-wb-preferences__agreement-form--copy-bold">MARKET DATA DEFINITION</span> - For all purposes of this Agreement, "Market Data" means
      <ol class="td-wb-preferences__agreement-form--secondary">
        <li class="td-wb-preferences__agreement-form--secondary-item">last sale information and quotation information relating to securities that are listed on a national
          securities exchange,
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">such bond and other equity last sale and quotation information, and such index and other market
          information, as United States-registered national securities exchanges and national securities
          associations (each, an "Authorizing SRO") may make available and as the American Stock
          Exchange ("AMEX") may from time to time designate as "Market Data"; and
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">all information that derives from any such information.</li>
      </ol>
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item"><span class="td-wb-preferences__agreement-form--copy-bold">PROPRIETARY NATURE OF DATA</span> - Subscriber understands and acknowledges that each Authorizing
    SRO and Other Data Disseminator has a proprietary interest in the Market Data that originates on or derives
    from it or its market(s).
  </li>
  <li class="td-wb-preferences__agreement-form--primary-item"><span class="td-wb-preferences__agreement-form--copy-bold">ENFORCEMENT</span> - Subscriber understands and acknowledges that
  <ol class="td-wb-preferences__agreement-form--secondary">
    <li class="td-wb-preferences__agreement-form--secondary-item">the Authorizing SROs are third-party beneficiaries under this Agreement and</li>
    <li class="td-wb-preferences__agreement-form--secondary-item">the Authorizing SROs or their authorized representative(s) may enforce this Agreement, by legal
      proceedings or otherwise, against Subscriber or any person that obtains Market Data that is made
      available pursuant to this Agreement other than as this Agreement contemplates. Subscriber shall pay
      the reasonable attorney's
      fees that any Authorizing SRO incurs in enforcing this Agreement against Subscriber.
    </li>
  </ol>
</li>
<li class="td-wb-preferences__agreement-form--primary-item"><span class="td-wb-preferences__agreement-form--copy-bold">DATA NOT GUARANTEED</span> - Subscriber understands that no Authorizing SRO, no other entity whose
information is made available over the Authorizing SROs' facilities (an "Other Data Disseminator")
and no information processor that assists any Authorizing SRO or other Data Disseminator in making Market
Data available (collectively, the "Disseminating Parties") guarantees the timeliness, sequence,
accuracy or completeness of Market Data or of other market information or messages disseminated by any
Disseminating Party. Neither Subscriber nor any other person shall hold any Disseminating Party liable in
any way for
<ol class="td-wb-preferences__agreement-form--secondary">
  <li class="td-wb-preferences__agreement-form--secondary-item">any inaccuracy, error or delay in, or omission of,
    <ol class="td-wb-preferences__agreement-form--tertiary">
      <li class="td-wb-preferences__agreement-form--tertiary-item">any such data, information or message or</li>
      <li class="td-wb-preferences__agreement-form--tertiary-item">the transmission or delivery of any such data, information or message, or</li>
    </ol>
  </li>
  <li class="td-wb-preferences__agreement-form--secondary-item">any loss or damage arising from or occasioned by
    <ol class="td-wb-preferences__agreement-form--tertiary">
      <li class="td-wb-preferences__agreement-form--tertiary-item">any such inaccuracy, error, delay or omission,</li>
      <li class="td-wb-preferences__agreement-form--tertiary-item">non-performance or</li>
      <li class="td-wb-preferences__agreement-form--tertiary-item">interruption in any such data, information or message, due either to any negligent act or
        omission by any Disseminating Party, to any "force majeure" (e.g., flood,
        extraordinary weather conditions, earthquake or other act of God, fire, war, insurrection,
        riot, labor dispute, accident, action of government, communications or power failure,
        equipment or software malfunction) or to any other cause beyond the reasonable control of
        any Disseminating Party.
      </li>
    </ol>
  </li>
</ol>
</li>
<li class="td-wb-preferences__agreement-form--primary-item"><span class="td-wb-preferences__agreement-form--copy-bold">PERMITTED USE</span> - Subscriber shall not furnish Market Data to any other person or entity and,
subject to Paragraph 10, shall use Market Data only for its individual use in its business.
</li>
<li class="td-wb-preferences__agreement-form--primary-item"><span class="td-wb-preferences__agreement-form--copy-bold">DISSEMINATION DISCONTINUANCE OR MODIFICATION</span> - Subscriber understands and acknowledges
that, at any time, the Authorizing SROs may discontinue disseminating any category of Market Data, may
change or eliminate any transmission method and may change transmission speeds or other signal
characteristics. The Authorizing SROs shall not be liable for any resulting liability, loss or damages that
may arise therefrom.
</li>
<li class="td-wb-preferences__agreement-form--primary-item"><span class="td-wb-preferences__agreement-form--copy-bold">DURATION; SURVIVAL</span> - This Agreement remains in effect for so long as Subscriber has the
ability to receive Market
Data as contemplated by this Agreement. In addition, Vendor may terminate this Agreement at any time,
whether at the direction of the Authorizing SROs or otherwise. Paragraphs 2, 3 and 4, and the first two
sentences of Paragraph 8, survive any termination of this Agreement.
</li>
<li class="td-wb-preferences__agreement-form--primary-item"><span class="td-wb-preferences__agreement-form--copy-bold">MISCELLANEOUS</span> - The laws of the State of New York shall govern this Agreement and it shall
be interpreted in accordance with those laws. This Agreement is subject to the Securities Exchange Act of
1934, the rules promulgated under that act, and the joint-industry plans entered into pursuant to that act.
This writing contains the entire agreement between the parties in respect of its subject matter. Subscriber
may not assign all or any part of this Agreement to any other person. The person manifesting assent to this
agreement below represents and warrants that it has legal capacity to contract and, if that person is
manifesting assent on behalf of a proprietorship or a business, partnership or other organization,
represents and warrants that he or she has actual authority to bind the organization.
</li>


<p class="td-wb-preferences__agreement-form--title td-wb-preferences__agreement-form--inline-title">SECTION 2: NON-PROFESSIONAL SUBSCRIBER</p>
<li class="td-wb-preferences__agreement-form--primary-item"><span class="td-wb-preferences__agreement-form--copy-bold">NON-PROFESSIONAL SUBSCRIBER DEFINITION</span> - "Non-Professional Subscriber" means any
natural person whom Vendor has determined to qualify as a "Non-Professional Subscriber" and who is not:
<ol class="td-wb-preferences__agreement-form--secondary">
  <li class="td-wb-preferences__agreement-form--secondary-item">registered or qualified with the Securities and Exchange Commission (the "SEC"), the
    Commodities Futures Trading Commission, any state securities agency, any securities exchange or
    association, or any commodities or futures contract market or association.
  </li>
  <li class="td-wb-preferences__agreement-form--secondary-item">engaged as an "investment advisor" as that term is defined in Section 202 (11) (a) of the
    Investment Advisor's Act of 1940 (whether or not registered or qualified under that Act), nor
  </li>
  <li class="td-wb-preferences__agreement-form--secondary-item">employed by a bank or other organization exempt from registration under Federal and/or state
    securities laws to perform functions that would require him or her to be so registered or qualified
    if he or she were to perform such functions for an organization not so exempt.
  </li>
</ol>
</li>
<li class="td-wb-preferences__agreement-form--primary-item"><span class="td-wb-preferences__agreement-form--copy-bold">PERMITTED USE</span> - If Subscriber is a Non-Professional Subscriber, he or she shall receive
Market Data solely for his or her personal, non-business use.
</li>
<li class="td-wb-preferences__agreement-form--primary-item"><span class="td-wb-preferences__agreement-form--copy-bold">PERSONAL AND EMPLOYMENT DATA</span> - As a prerequisite to qualifying as a "Non-Professional
Subscriber", Subscriber shall provide the following information:

@if (!disabled()) {
  <div>
    <ng-container *ngTemplateOutlet="form" />
  </div>
}

<p class="td-wb-preferences__agreement-form--copy">Subscriber shall notify Vendor promptly in writing of any change in his or her circumstances that may
cause him or her to cease to qualify as a Non-Professional Subscriber.</p>
</li>
<li class="td-wb-preferences__agreement-form--primary-item"><span class="td-wb-preferences__agreement-form--copy-bold">CERTIFICATION</span> - By clicking on the following box, Subscriber hereby certifies that he or
she falls within Paragraph 9's definition of "Non-Professional Subscriber" and that the personal
and employment information that he or she has included in Paragraph 11 is truthful and accurate.
</li>
</ol>
<p class="td-wb-preferences__agreement-form--copy"><span>ACCEPTED AND AGREED</span> I, the "Subscriber" to which the preceding terms and conditions refer, acknowledge
that I have read the preceding terms and conditions of Sections 1 and 2, that I understand them and that I hereby
manifest my assent to, and my agreement to comply with, those terms and conditions by "clicking" on
"I Accept":</p>
@if (disabled()) {
  <p class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--copy-bold">
    <span>Dated: </span>
    <span [innerText]="selectedAgreementEffectiveDate | tdWbDate: { format: 'DATE_TIME' }"></span>
  </p>
}
</div>
</ng-template>

<!--TEMPLATES FRENCH-->
<ng-template #fr>
  <div class="td-wb-preferences__agreement-form">
    <h1 class="td-wb-preferences__agreement-form__header">Entente du souscripteur AMEX - Non professionnel</h1>
    @if (disabled()) {
      <td-wb-notification class="td-wb-preferences-agreements__completed"
                          notificationType="success">
        Copie pour « À des fins de visualisation seulement » :
        Aucune mesure à prendre, ce contrat a été accepté. Merci.
      </td-wb-notification>
    }
    <p class="td-wb-preferences__agreement-form--title">CONTRAT D'ABONNEMENT de AMEX AUX SERVICES DE DIFFUSION DES DONNÉES DE MARCHÉ<br>(Services axés sur l'utilisation par un abonné non professionnel)</p>

    <p class="td-wb-preferences__agreement-form--copy">TD Waterhouse Canada Inc. (le fournisseur) convient de mettre à votre disposition les données du marché
      conformément aux modalités énoncées dans le présent contrat. En indiquant votre consentement dans l'espace prévu
      ci dessous à cette fin, vous (l'abonné) convenez de respecter les présentes modalités. L'article 1 énonce les
      modalités générales. L'article 2 s'applique tant que l'abonné reçoit et utilise les données du marché
    disponibles aux termes du présent contrat à titre d'abonné non professionnel.</p>

    <p class="td-wb-preferences__agreement-form--title">ARTICLE 1 - MODALITÉS GÉNÉRALES</p>
    <ol class="td-wb-preferences__agreement-form--primary td-wb-preferences__agreement-form--copy">
      <li class="td-wb-preferences__agreement-form--primary-item"><span class="td-wb-preferences__agreement-form--copy-bold">DÉFINITION DES DONNÉES DU MARCHÉ</span> - À toutes les fins du présent contrat, l'expression données du marché
      s'entend
      <ol class="td-wb-preferences__agreement-form--secondary">
        <li class="td-wb-preferences__agreement-form--secondary-item"> des renseignements sur les dernières ventes et cotes relativement aux titres inscrits à la cote
          d'une bourse nationale des valeurs,
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">des renseignements sur les dernières ventes et cotes des obligations et
          autres titres de participation, ainsi que des renseignements sur les indices et autres renseignements sur le
          marché que les bourses nationales des valeurs et les associations nationales des valeurs inscrites aux États
          Unis (chacune, un OAR habilitant) peuvent rendre disponibles, et que l'American Stock Exchange (AMEX) peut de
          temps à autre désigner comme étant des données du marché, et
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">toute l'information découlant de ces
        renseignements.</li>
      </ol>
    </li>
    <li class="td-wb-preferences__agreement-form--primary"><span class="td-wb-preferences__agreement-form--copy-bold">NATURE EXCLUSIVE DES DONNÉES</span> - L'abonné conçoit et reconnaît que chaque OAR habilitant et chaque autre
    diffuseur des données ont un droit d'exclusivité sur les données du marché qui proviennent de leurs marchés.
  </li>
  <li class="td-wb-preferences__agreement-form--primary"><span class="td-wb-preferences__agreement-form--copy-bold">MISE À EXÉCUTION</span> - L'abonné conçoit et reconnaît
  <ol class="td-wb-preferences__agreement-form--secondary">
    <li class="td-wb-preferences__agreement-form--secondary-item">que les OAR habilitants sont des tiers
    bénéficiaires aux termes du présent contrat, et</li>
    <li class="td-wb-preferences__agreement-form--secondary-item">que les OAR habilitants ou leurs représentants autorisés
      peuvent opposer le présent contrat, au moyen de poursuites judiciaires ou autrement, à l'abonné ou à toute autre
      personne qui obtient les données du marché rendues accessibles aux termes du présent contrat autrement que de la
      manière prévue aux présentes. L'abonné paie les frais d'avocat raisonnables engagés par tout OAR habilitant pour
      opposer le présent contrat à l'abonné.
    </li>
  </ol>
</li>
<li class="td-wb-preferences__agreement-form--primary"><span class="td-wb-preferences__agreement-form--copy-bold">DONNÉES NON GARANTIES</span> - L'abonné conçoit qu'aucun OAR habilitant, ni aucune autre entité dont les
renseignements sont rendus accessibles au moyen des installations des OAR habilitants (un autre diffuseur de
données), non plus qu'aucun organisme de traitement des données aidant un OAR habilitant ou un autre diffuseur
des données à diffuser les données du marché (collectivement, les diffuseurs) ne garantit l'actualité, la
séquence, l'exactitude ou l'exhaustivité des données du marché ou des autres renseignements ou messages du
marché publiés par tout diffuseur. Ni l'abonné ni toute autre personne ne tiendra un diffuseur responsable de
quelque façon que ce soit
<ol class="td-wb-preferences__agreement-form--secondary">
  <li class="td-wb-preferences__agreement-form--secondary-item">d'une inexactitude, d'une erreur, d'un retard ou d'une omission relativement
    <ol class="td-wb-preferences__agreement-form--tertiary">
      <li class="td-wb-preferences__agreement-form--tertiary-item"> à ces données, renseignements ou messages, ou</li>
      <li class="td-wb-preferences__agreement-form--tertiary-item">à la transmission ou la remise de ces données, renseignements ou messages, ou</li>
    </ol>
  </li>
  <li class="td-wb-preferences__agreement-form--secondary-item">de toute perte ou de tout dommage résultant
    <ol class="td-wb-preferences__agreement-form--tertiary">
      <li class="td-wb-preferences__agreement-form--tertiary-item">d'une telle inexactitude ou erreur ou d'un tel retard ou omission,</li>
      <li class="td-wb-preferences__agreement-form--tertiary-item">de la non-exécution ou</li>
      <li class="td-wb-preferences__agreement-form--tertiary-item">de l'interruption de ces données, renseignements ou
        messages, à cause de la négligence ou de l'omission par négligence d'un diffuseur, de tout cas de force majeure
        (p. ex., une inondation, des conditions météorologiques anormales, un séisme ou un autre cas de force majeure,
        un incendie, une guerre, une insurrection, une émeute, un conflit de travail, un accident, une mesure du
        gouvernement, une panne de communication ou d'électricité, un mauvais fonctionnement du matériel ou d'un
        logiciel) ou de toute autre cause indépendante de la volonté raisonnable de tout diffuseur.
      </li>
    </ol>
  </li>
</ol>
</li>
<li class="td-wb-preferences__agreement-form--primary"><span class="td-wb-preferences__agreement-form--copy-bold">UTILISATION AUTORISÉE</span> - L'abonné ne doit communiquer les données du marché à aucune autre personne ou
entité et, sous réserve du paragraphe 10, il doit utiliser les données du marché uniquement pour son usage
personnel dans le cadre de son entreprise.
</li>

<li class="td-wb-preferences__agreement-form--primary"><span class="td-wb-preferences__agreement-form--copy-bold">CESSATION OU MODIFICATION DE LA DIFFUSION</span> - L'abonné conçoit et reconnaît que les OAR habilitants
peuvent en tout temps cesser la diffusion de toute catégorie de données du marché, changer ou éliminer toute
méthode de transmission et modifier les vitesses de transmission ou d'autres caractéristiques du signal. Les OAR
habilitants sont dégagés de toute responsabilité ou perte ou de tout dommage
</li>

<li class="td-wb-preferences__agreement-form--primary"><span class="td-wb-preferences__agreement-form--copy-bold">DURÉE ET CONTINUATION</span> - Le présent contrat demeure en vigueur tant que l'abonné est en mesure de
recevoir les données du marché tel qu'il est indiqué dans ce contrat. De plus, le fournisseur peut résilier le
présent contrat en tout temps, selon les directives des OAR habilitants ou autrement. Les paragraphes 2, 3 et 4,
ainsi que les deux premières phrases du paragraphe 8 continueront d'exister après la résiliation du présent
contrat.
</li>

<li class="td-wb-preferences__agreement-form--primary"><span class="td-wb-preferences__agreement-form--copy-bold">DISPOSITIONS DIVERSES</span> - Les lois de l'État de New York régissent le présent contrat et celui-ci est
interprété conformément à ces lois. Ce contrat est assujetti à la loi intitulée Securities Exchange Act of 1934,
aux règles promulguées en vertu de cette loi, ainsi qu'aux régimes intersectoriels conclus aux termes de cette
loi. Le présent texte constitue l'entente intégrale entre les parties à l'égard de son objet. L'abonné ne peut
céder à quiconque ni la totalité ni aucune partie du présent contrat. La personne donnant ci-après son
consentement au présent contrat déclare et garantit qu'elle a la capacité juridique de signer un contrat et, si
cette personne donne son consentement pour le compte d'une entreprise individuelle ou d'un commerce, d'une
société de personnes ou d'un autre organisme, cette personne déclare et garantit qu'elle a le pouvoir réel de
lier l'organisme.
</li>
<p class="td-wb-preferences__agreement-form--inline-title">ARTICLE 2 - ABONNÉ NON PROFESSIONNEL</p>
<li class="td-wb-preferences__agreement-form--primary">
  <span class="td-wb-preferences__agreement-form--copy-bold">DÉFINITION DE L'ABONNÉ NON PROFESSIONNEL</span> - Un abonné non professionnel s'entend de toute personne
  physique qui, tel que le fournisseur l'a déterminé, est admissible en tant qu'abonné non professionnel et qui :
  <ol class="td-wb-preferences__agreement-form--secondary">
    <li class="td-wb-preferences__agreement-form--tertiary-item">n'est pas inscrite ou agréée auprès de la Securities and Exchange Commission (la SEC), la Commodities Futures
      Trading Commission, tout organisme d'État des valeurs mobilières, toute bourse ou association des valeurs
      mobilières ou tout marché ou toute association de marchandises ou de contrats à terme;
    </li>
    <li class="td-wb-preferences__agreement-form--tertiary-item">n'est pas engagée à titre de conseiller en placements, au sens donné à l'expression correspondante à l'article
      201(11) de la loi intitulée Investment Advisor's Act of 1940 (qu'elle soit ou non inscrite ou agréée en vertu de
      cette loi); ni
    </li>
    <li class="td-wb-preferences__agreement-form--tertiary-item">n'est employée par une banque ou un autre organisme dispensé des exigences d'inscription en vertu des lois
      fédérales et(ou) étatiques sur les valeurs mobilières pour pouvoir remplir les fonctions qui l'obligeraient à
      être ainsi inscrite ou agréée si elle devait les exécuter pour le compte d'un organisme non ainsi dispensé
    </li>
  </ol>
</li>
<li class="td-wb-preferences__agreement-form--primary"><span class="td-wb-preferences__agreement-form--copy-bold">UTILISATION AUTORISÉE</span> - Si l'abonné est un abonné non professionnel, il recevra les données du marché
uniquement à des fins personnelles, non reliées à une entreprise.
</li>
<li class="td-wb-preferences__agreement-form--primary"><span class="td-wb-preferences__agreement-form--copy-bold">DONNÉES PERSONNELLES ET SUR L'EMPLOI</span> - Afin d'être admissible à titre d'abonné non professionnel,
l'abonné doit fournir les renseignements suivants :

@if (!disabled()) {
  <div>
    <ng-container *ngTemplateOutlet="form" />
  </div>
}

<p class="td-wb-preferences__agreement-form--copy">L'abonné doit aviser le fournisseur sans délai par écrit de tout changement dans sa situation par suite duquel il
n'est plus admissible en tant qu'abonné non professionnel.</p>
</li>
<li class="td-wb-preferences__agreement-form--primary"><span class="td-wb-preferences__agreement-form--copy-bold">CERTIFICATION</span> - En cliquant sur la case ci-après, l'abonné certifie par les présentes qu'il ou elle
correspond à la définition d'abonné non professionnel du paragraphe 9 et que les renseignements personnels et
sur l'emploi qu'il a fournis au paragraphe 11 sont véridiques et exacts.
</li>
</ol>
<p class="td-wb-preferences__agreement-form--copy">ACCEPTÉ : Je, l'abonné auquel renvoient les modalités précédentes,
  reconnais avoir lu les modalités du présent sections 1 et 2, les comprendre, y consentir par les présentes et convenir de les respecter en «
  cliquant » sur la case
suivante :</p>
@if (disabled()) {
  <p class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--copy-bold">
    <span>daté : </span>
    <span [innerText]="selectedAgreementEffectiveDate | tdWbDate: { format: 'DATE_TIME' }"></span>
  </p>
}
</div>
</ng-template>

<!--FORM TEMPLATE-->
<ng-template #form>
  <td-wb-form novalidate autocomplete="off">
    <td-wb-form-row>
      <div class="td-wb-preferences__agreement-form--input-row">
        <!--SUBSCRIBER_NAME-->
        <td-wb-input-group class="td-wb-preferences__agreement-form--input-group">
          <td-wb-input-group-label>
            <label for="clientName" translate="tdWb.platform.preferences.agreements.AMEX.SUBSCRIBER_NAME">
            </label>
          </td-wb-input-group-label>
          <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
            <input type="text"
              id="clientName"
              name="clientName"
              class="td-wb-full-width"
              [required]="!consolidateAgreement()"
              [attr.aria-required]="!consolidateAgreement()"
              maxlength="35"
              [disabled]="consolidateAgreement()"
              [attr.aria-disabled]="consolidateAgreement()"
              [(ngModel)]="formModel.clientName"
              tdWbInput>
              <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR" />
            </td-wb-input-group-field>
          </td-wb-input-group>
          <td-wb-input-group class="td-wb-preferences__agreement-form--input-group">
            <!--SUBSCRIBER_ADDRESS-->
            <td-wb-input-group-label>
              <label for="clientAddress" translate="tdWb.platform.preferences.agreements.AMEX.SUBSCRIBER_ADDRESS">
              </label>
            </td-wb-input-group-label>
            <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
              <input type="text"
                id="clientAddress"
                name="clientAddress"
                class="td-wb-full-width"
                [required]="!consolidateAgreement()"
                [attr.aria-required]="!consolidateAgreement()"
                maxlength="100"
                [disabled]="consolidateAgreement()"
                [attr.aria-disabled]="consolidateAgreement()"
                [(ngModel)]="formModel.clientAddress"
                tdWbInput>
                <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR" />
              </td-wb-input-group-field>
            </td-wb-input-group>
          </div>
          <div class="td-wb-preferences__agreement-form--input-row">
            <!--SUBSCRIBER_OCCUPATIONS-->
            <td-wb-input-group class="td-wb-preferences__agreement-form--input-group">
              <td-wb-input-group-label class="td-wb-preferences__agreement-form--input-label">
                <label for="clientOccupation" translate="tdWb.platform.preferences.agreements.AMEX.SUBSCRIBER_OCCUPATIONS">
                </label>
              </td-wb-input-group-label>
              <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
                <input type="text"
                  id="clientOccupation"
                  name="clientOccupation"
                  class="td-wb-full-width"
                  [required]="!consolidateAgreement()"
                  [attr.aria-required]="!consolidateAgreement()"
                  maxlength="100"
                  [disabled]="consolidateAgreement()"
                  [attr.aria-disabled]="consolidateAgreement()"
                  [(ngModel)]="formModel.clientOccupation"
                  tdWbInput>
                  <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR" />
                </td-wb-input-group-field>
              </td-wb-input-group>
              <td-wb-input-group class="td-wb-preferences__agreement-form--input-group">
                <td-wb-input-group-label class="td-wb-preferences__agreement-form--input-label">
                  <label for="clientEmployerNameAddress"
                    translate="tdWb.platform.preferences.agreements.AMEX.SUBSCRIBER_EMPLOYER_INFO">
                  </label>
                </td-wb-input-group-label>
                <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
                  <input type="text"
                    id="clientEmployerNameAddress"
                    name="clientEmployerNameAddress"
                    class="td-wb-full-width"
                    [required]="!consolidateAgreement()"
                    [attr.aria-required]="!consolidateAgreement()"
                    maxlength="130"
                    [disabled]="consolidateAgreement()"
                    [attr.aria-disabled]="consolidateAgreement()"
                    [(ngModel)]="formModel.clientEmployerNameAddress"
                    tdWbInput>
                    <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR" />
                  </td-wb-input-group-field>
                </td-wb-input-group>
              </div>
              <div class="td-wb-preferences__agreement-form--input-row">
                <!--SUBSCRIBER_TITLE-->
                <td-wb-input-group class="td-wb-preferences__agreement-form--input-group">
                  <td-wb-input-group-label>
                    <label for="clientTitlePosition" translate="tdWb.platform.preferences.agreements.AMEX.SUBSCRIBER_TITLE">
                    </label>
                  </td-wb-input-group-label>
                  <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
                    <input type="text"
                      id="clientTitlePosition"
                      name="clientTitlePosition"
                      class="td-wb-full-width"
                      [required]="!consolidateAgreement()"
                      [attr.aria-required]="!consolidateAgreement()"
                      maxlength="75"
                      [disabled]="consolidateAgreement()"
                      [attr.aria-disabled]="consolidateAgreement()"
                      [(ngModel)]="formModel.clientTitlePosition"
                      tdWbInput>
                      <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR" />
                    </td-wb-input-group-field>
                  </td-wb-input-group>
                  <td-wb-input-group class="td-wb-preferences__agreement-form--input-group">
                    <!--SUBSCRIBER_EMPLOYMENT_FUNCTIONS-->
                    <td-wb-input-group-label>
                      <label for="clientEmployerFunction"
                        translate="tdWb.platform.preferences.agreements.AMEX.SUBSCRIBER_EMPLOYMENT_FUNCTIONS">
                      </label>
                    </td-wb-input-group-label>
                    <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
                      <input type="text"
                        id="clientEmployerFunction"
                        name="clientEmployerFunction"
                        class="td-wb-full-width"
                        [required]="!consolidateAgreement()"
                        [attr.aria-required]="!consolidateAgreement()"
                        maxlength="100"
                        [disabled]="consolidateAgreement()"
                        [attr.aria-disabled]="consolidateAgreement()"
                        [(ngModel)]="formModel.clientEmployerFunction"
                        tdWbInput>
                        <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR" />
                      </td-wb-input-group-field>
                    </td-wb-input-group>
                  </div>
                </td-wb-form-row>
              </td-wb-form>

            </ng-template>
